"use client"
import { Box, Button, Card, Flex, Heading, Icon, Stack, Text } from '@chakra-ui/react';
import { FiClock, FiTarget, FiUsers } from 'react-icons/fi';
import { LuCheck } from 'react-icons/lu';
import { NavLink } from 'react-router-dom';

const offers = [
  {
    title: "Kurs ósmoklasisty",
    description: "Doskonale znamy wymagania egzaminacyjne, dlatego wyniki 100% u naszych uczniów nie są rzadkością. Małe grupy, pozytywne wsparcie i regularna, weryfikowana przez nas praca domowa to połączenie gwarantujące przewagę w wyścigu o miejsce w dobrej szkole średniej.",
    price: "Od 249 zł/m-c.",
    benefits: [
      "Bardzo małe grupy (3 - 6 osób)",
      "Kumulatywne powtórki i prace domowe",
      "Im więcej przedmiotów, tym lepsza cena",
    ],
    details: [
      { icon: FiTarget, value: "uczniowie klas 8" },
      { icon: FiUsers, value: "3-6" },
      { icon: FiClock, value: "60 min" },
    ],
    results: [
      { label: 'matematyka', national: 55, ours: 79 },
      { label: 'język polski', national: 65, ours: 83 },
      { label: 'język angielski', national: 73, ours: 89 },
    ],
    featured: true,
    slug: "osmoklasisty",
  },
  {
    title: "Kurs maturalny",
    description: "Skuteczne przygotowanie do matury to przede wszystkim praktyczne ćwiczenia pod okiem doświadczonego nauczyciela. W niewielkiej grupie każdy aktywnie uczestniczy w zajęciach, a przygotowane przez nas w oparciu o aktualne wymagania materiały pomogą Ci osiągnąć świetny wynik i dostać się na wymarzone studia.",
    price: "Od 359 zł/m-c",
    benefits: [
      "Bardzo małe grupy (3 - 6 osób)",
      "98% naszych uczniów zdało maturę",
      "Im więcej przedmiotów, tym lepsza cena",
    ],
    details: [
      { icon: FiTarget, value: "maturzyści" },
      { icon: FiUsers, value: "3-6" },
      { icon: FiClock, value: "90 min" },
    ],
    results: [
      { label: 'matematyka – p.\u00A0podstawowy', national: 59, ours: 72 },
      { label: 'matematyka – p.\u00A0rozszerzony', national: 37, ours: 84 },
      { label: 'j. polski – p.\u00A0podstawowy', national: 59, ours: 69 },
      { label: 'j. polski – p.\u00A0rozszerzony', national: 44, ours: 66 },
    ],
    featured: false,
    slug: "maturalne",
  },
]

export default function HomeLessons() {
  return (
    <Box id="kursy" as="section" py="16" px={{ base: "4", md: "8" }} bg="gray.50">
      <Flex direction="column" gap="8" maxW="7xl" mx="auto">
        <Stack gap="3" maxW="2xl">
          <Text fontSize='lg' color="brand.orange.500" fontWeight="semibold" textTransform="uppercase" letterSpacing="wider">
            Oferta kursów
          </Text>
        </Stack>

        <Stack gap={{ base: "6", md: "8" }}>
          {offers.map((offer) => (
            <Card.Root
              key={offer.title}
              borderWidth="1px"
              borderColor="border.muted"
              bg="canvas.subtle"
              boxShadow="sm"
              p="6"
              rounded="3xl"
              w="full"
            >
              <Flex direction="column" gap="6" h="full">
                <Stack gap="4">
                  <Flex direction="row" align="center" justify="space-between">
                    <Heading size="xl">{offer.title}</Heading>
                  </Flex>

                  <Flex wrap="wrap" gap="4" color="muted">
                    {offer.details.map((detail) => (
                      <Flex key={`${offer.title}-${detail.value}`} align="center" gap="2.5" fontSize="sm">
                        <Icon as={detail.icon} color="orange.500" boxSize="4.5" flexShrink={0} />
                        <Text color="gray.700">{detail.value}</Text>
                      </Flex>
                    ))}
                  </Flex>

                  <Box color="muted" fontStyle="normal">
                    <Text color="muted">{offer.description}</Text>
                  </Box>
                </Stack>

                <Stack gap="4">
                  <Text fontSize="2xl" fontWeight="semibold">
                    {offer.price}
                  </Text>
                  <Stack as="ul" gap="3" pl="0">
                    {offer.benefits.map((benefit) => (
                      <Flex key={benefit} align="center" gap="2">
                        <Icon as={LuCheck} color="orange.500" boxSize="4" flexShrink={0} />
                        <Text color="muted">
                          {benefit}
                        </Text>
                      </Flex>
                    ))}
                  </Stack>
                </Stack>

                <Stack gap="4" pt="4" borderTop="1px solid" borderColor="gray.200">
                  <Flex gap="2" align="center" mb="1" direction={{base: 'column', md: 'row'}}>
                    <Text fontSize="lg" fontWeight="semibold" color="gray.700" alignSelf="flex-start">
                      Średnie wyniki po ukończeniu kursu:
                    </Text>
                    <Flex alignSelf={{base: 'flex-start', md: 'flex-end'}} gap="4" flexGrow={1} justify={{base: 'flex-start', md: 'flex-end'}} wrap="wrap">
                      <Flex align="center" gap="2">
                        <Box w="12px" h="12px" bg="gray.300" borderRadius="full" />
                        <Text fontSize="md" color="muted">Polska</Text>
                      </Flex>
                      <Flex align="center" gap="2">
                        <Box w="12px" h="12px" bg="brand.900" borderRadius="full" />
                        <Text fontSize="md" color="muted">Nasi kursanci</Text>
                      </Flex>
                    </Flex>
                  </Flex>

                  <Box position="relative" p="0">
                    <Flex align="end" justify="center" gap="4" wrap="wrap" h="auto" position="relative" pb="2">
                      {offer.results.map((result) => (
                        <Flex
                          key={result.label}
                          direction="column"
                          align="center"
                          justify="end"
                          gap="2"
                          flex="1 1 120px"
                          minW={{ base: "120px", md: "240px"}}
                          maxW="240px"
                        >
                          <Flex align="end" justify="center" gap="3" h="140px" w="full" borderBottom="1px solid" borderColor="gray.200">
                            <Box
                              w="72px"
                              h={`${result.national}%`}
                              minH="20px"
                              bg="gray.300"
                              borderRadius="full full 5px 5px"
                            >
                              <Text fontSize="sm" position='relative' left='23px' top='2px' fontWeight="semibold" color="muted">{result.national}%</Text>
                            </Box>
                            <Box
                              w="72px"
                              h={`${result.ours}%`}
                              minH="20px"
                              bg="brand.900"
                              borderRadius="full full 5px 5px"
                            >
                              <Text fontSize="sm" position='relative' left='23px' top='2px' fontWeight="semibold" color="white">{result.ours}%</Text>
                            </Box>
                            
                          </Flex>

                          <Text fontSize="md" color="muted" textAlign="center" lineHeight="1.3" textTransform="lowercase">
                            {result.label}
                          </Text>
                        </Flex>
                      ))}
                    </Flex>
                  </Box>
                </Stack>

                <NavLink to={`/zapisy/#${offer.slug}`}>
                    <Button
                        variant="outline"
                        colorPalette="orange"
                        size="lg"
                    >
                        Sprawdź terminy
                    </Button>
                </NavLink>
              </Flex>
            </Card.Root>
          ))}
        </Stack>
      </Flex>
    </Box>
  )
}
